import React, { useCallback, useEffect, useState } from 'react';
import statApi from 'api/stat/stat';
import Cookies from 'js-cookie';
import {
    CookieNames,
    CookieStateValues,
    HOURS_TO_REJECT,
    MS_IN_HOUR, UserStatus,
} from 'config/constants';
import { profileAPI } from 'api';
import { createPortal } from 'react-dom';
import { useApp } from 'context/AppContext';
import {
    ButtonsWrapper, Container, Text, Wrapper, Button,
} from './PPPortal.styled';

const getCookiePP = () => {
    const cookieState = Cookies.get(CookieNames.PP_STATE);
    const cookieDate = Cookies.get(CookieNames.PP_DATE);

    return [cookieState, cookieDate];
};

const parseCookieDate = (cookieDate?: string) => (cookieDate
    ? Number(String(cookieDate).trim()) || 0 : 0);

function PPPortal({ policyText }: { policyText: string }) {
    const [showBanner, setShowBanner] = useState(false);
    const { userStatus } = useApp();
    const { useSendStatsMutation, useLazyCheckStatusQuery } = statApi;
    const { data: dataProfile, isLoading: isLoadingProfile } = profileAPI.useGetShortProfileQuery(undefined, {
        skip: userStatus === UserStatus.Guest,
    });
    const [sendStats] = useSendStatsMutation();
    const [checkStats, { isLoading: statsLoading }] = useLazyCheckStatusQuery();
    const parentElem = document.getElementById('pp-portal') as HTMLElement;

    const onPPBtnClick = useCallback((state: boolean) => {
        const cookiesSet = () => {
            Cookies.set(
                CookieNames.PP_STATE,
                state
                    ? CookieStateValues.accepted
                    : CookieStateValues.rejected,
            );
            Cookies.set(CookieNames.PP_DATE, Date.now().toString());
        };

        setShowBanner(false);

        cookiesSet();

        if (dataProfile) {
            sendStats({
                msisdn: dataProfile.msisdn,
                accepted: state,
                timestamp: Date.now(),
            })
                .then((res) => {
                    if ('error' in res) cookiesSet();
                });
        }
    }, [dataProfile]);

    const checkWithCookies = useCallback(() => {
        const [cookieState, cookieDate] = getCookiePP();

        if (!cookieState) {
            setShowBanner(true);
            return;
        }

        if (cookieState === CookieStateValues.accepted) {
            setShowBanner(false);
            return;
        }

        if (cookieState === CookieStateValues.rejected) {
            if (!cookieDate) {
                setShowBanner(true);
                return;
            }

            const savedDate = parseCookieDate(cookieDate);
            const hoursPassed = (Date.now() - savedDate) / MS_IN_HOUR;
            setShowBanner(hoursPassed > HOURS_TO_REJECT);
            return;
        }

        setShowBanner(true);
    }, []);

    useEffect(() => {
        if (!dataProfile) return;

        const [cookieState, cookieDate] = getCookiePP();

        if (cookieState && cookieDate) {
            sendStats({
                msisdn: dataProfile.msisdn,
                accepted: Number(cookieState) === 1,
                timestamp: parseCookieDate(cookieDate),
            });
        }
    }, [dataProfile]);

    useEffect(() => {
        if (isLoadingProfile) return;

        if (!dataProfile) {
            checkWithCookies();

            return;
        }

        checkStats({ msisdn: dataProfile.msisdn })
            .then((res) => {
                if ('data' in res && res.data) {
                    setShowBanner(res.data.show_banner);
                } else {
                    checkWithCookies();
                }
            }).catch(() => {
                checkWithCookies();
            });
    }, [dataProfile, isLoadingProfile]);

    if (statsLoading || !showBanner) return null;

    return createPortal(
        <Container>
            <Wrapper>
                <Text dangerouslySetInnerHTML={{ __html: policyText }} />
                <ButtonsWrapper>
                    <Button $reject onClick={() => onPPBtnClick(false)}>Не принимаю</Button>
                    <Button onClick={() => onPPBtnClick(true)}>Принимаю</Button>
                </ButtonsWrapper>
            </Wrapper>
        </Container>,
        parentElem,
    );
}

export default PPPortal;
